import { forEach, keys } from 'lodash';
import { database } from './';
import { Stroke } from '../types';

export function createStroke({ start, end, strokeStyle, lineWidth, roomId }: Omit<Stroke, 'id'>) {
    const id = database.ref('strokes').push().key || '';

    const stroke: Stroke = {
        roomId,
        id,
        start,
        end,
        lineWidth,
        strokeStyle,
    };

    return database
        .ref(`strokes/${id}`)
        .set(stroke)
        .then(() => stroke);
}

export function getStrokesForRoomRef(roomId: string) {
    return database.ref('strokes').orderByChild('roomId').startAt(roomId).endAt(roomId);
}

export function clearStrokes(roomId: string) {
    return database
        .ref('strokes')
        .orderByChild('roomId')
        .startAt(roomId)
        .endAt(roomId)
        .once('value', (dataSnapshot) => {
            forEach(keys(dataSnapshot.val()), (strokeId) => {
                dataSnapshot.ref.child(strokeId).remove();
            });
        });
}
